import { render, staticRenderFns } from "./iFrameFeedback.vue?vue&type=template&id=fbbbaec2&scoped=true&"
import script from "./iFrameFeedback.vue?vue&type=script&lang=js&"
export * from "./iFrameFeedback.vue?vue&type=script&lang=js&"
import style0 from "./iFrameFeedback.vue?vue&type=style&index=0&id=fbbbaec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbbaec2",
  null
  
)

export default component.exports